import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

export interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'destructive' | 'primary';
  loading?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open, onClose, onConfirm, title, description,
  confirmLabel = 'Confirm', cancelLabel = 'Cancel',
  variant = 'destructive', loading,
}) => (
  <Modal open={open} onClose={onClose} title={title} description={description} size="sm">
    <div className="flex justify-end gap-2 pt-2">
      <Button variant="secondary" size="sm" onClick={onClose} disabled={loading}>
        {cancelLabel}
      </Button>
      <Button variant={variant === 'destructive' ? 'destructive' : 'primary'} size="sm" onClick={onConfirm} disabled={loading}>
        {confirmLabel}
      </Button>
    </div>
  </Modal>
);
